const WEEK = 7 * 24 * 3600 * 1000;

// Jeu publié depuis moins de 7 jours.
export const isNewGame = (g) => {
  const t = Date.parse(g?.published_at || g?.created_at || "");
  return !Number.isNaN(t) && Date.now() - t < WEEK;
};

export function NewBadge({ count, testId }) {
  return (
    <span data-testid={testId} className="inline-flex items-center rounded-full bg-amber-400 text-amber-950 text-xs font-black uppercase tracking-wide px-2.5 py-1 align-middle ml-2 shadow-sm">
      {count > 1 ? `${count} nouveaux` : "Nouveau"}
    </span>
  );
}
